import { FilterConfigStatic } from '@/types/filter';
import { Filter } from '@cubejs-client/core';

export enum SourceSytem {
  OCEP = 'ocep',
  RELTIO = 'reltio',
}

const sourceSystemFilter: FilterConfigStatic = {
  label: 'global.filters.formControls.sourceSystemLabel',
  options: [
    { value: SourceSytem.OCEP, label: 'OCE-P' },
    { value: SourceSytem.RELTIO, label: 'Reltio' },
  ],
  defaultValue: [],
  type: 'multiselect',
  clearable: true,
  placeholder: 'global.filters.formControls.sourceSytemPlaceholder',
  format: ({ value, t }) => 'In ' + t(`global.filters.sourceSystems.${value}`),
  applyFilter: value => {
    const v = value as string[];
    const sourceSystemFilterExpression: Filter = { or: [] };
    if (v.includes(SourceSytem.OCEP)) {
      sourceSystemFilterExpression.or.push({
        member: `hcp.is_in_ocep`,
        operator: 'equals',
        values: ['true'],
      });
    }
    if (v.includes(SourceSytem.RELTIO)) {
      sourceSystemFilterExpression.or.push({
        member: `hcp.is_in_reltio`,
        operator: 'equals',
        values: ['true'],
      });
    }
    return sourceSystemFilterExpression;
  },
};

export default sourceSystemFilter;
